<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="closeModel()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>Nachrichten</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content NoScrollbar class="ion-padding">

  <ion-fab vertical="bottom" horizontal="end" slot="fixed" mode="ios">
    <ion-fab-button (click)="newContent()" >
      <ion-icon style="font-size: 22px;" name="fa-plus"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  @for (c of content; track c) {
    <app-workstep-content [content]="c" (onDelete)="delete(c)" (onEdit)="onWorkstepContentEdit($event)"></app-workstep-content>
  }

  @if (content.length == 0) {
    <p class="no-content">Keine Einträge vorhanden</p>
  }

</ion-content>
